import { useTranslation } from "react-i18next";
import { Card, CardBody } from "react-bootstrap";
import { useEffect, useState } from "react";
import crudApi from "@serie3/common/api/crudApi";
import DashboardEndpoints from "@serie3/mymediaplanner/Modules/Dashboard/endpoints";
import ListElement from "./ListElement";
import getDashboardUrl from "@serie3/mymediaplanner/Modules/Dashboard/Domain/getDashboardUrl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandshake } from "@fortawesome/free-solid-svg-icons";

const Accountability = ({ monthYear }) => {
  const { t } = useTranslation();
  const [planData, setPlanData] = useState(null);

  useEffect(() => {
    const getData = async () => {
      const url = getDashboardUrl(DashboardEndpoints.outreach, monthYear);
      const response = await crudApi.justGet(url);
      if (response.ok) setPlanData(response.data);
    };
    getData();
  }, [monthYear]);

  return (
    <Card style={{ borderRadius: 16, border: "1px solid #eaecf0", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
      <CardBody>
        <h4 className="page-section-header" style={{ marginBottom: 16 }}>
          <span className="page-section-header-icon" style={{ background: "rgba(86,74,177,0.12)" }}>
            <FontAwesomeIcon icon={faHandshake} style={{ color: "#564ab1" }} />
          </span>
          {t("Backend.Dashboard.OutreachTitle", "Outreach")}
        </h4>
        <div>
          {planData && (
            <ListElement title={t("Backend.Dashboard.SendRequests")} data={planData.connectionRequestsCount} icon="uil uil-user-plus" />
          )}
          {planData && (
            <ListElement title={t("Backend.Dashboard.SendMessages")} data={planData.messageCount} icon="uil uil-envelope" />
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default Accountability;
